import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_3 = { class: "card-body border-top p-9" }
const _hoisted_4 = { class: "row mb-6" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_7 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar"
}
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 fv-row" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "col-lg-6 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "row mb-6" }
const _hoisted_22 = { class: "col-lg-8 fv-row" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = { class: "col-lg-8 fv-row" }
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "row mb-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "row mb-6" }
const _hoisted_42 = { class: "col-lg-8 fv-row" }
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_46 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton1",
  class: "btn btn-primary"
}
const _hoisted_47 = { class: "card mb-5 mb-xl-10" }
const _hoisted_48 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_49 = { class: "card-body border-top p-9" }
const _hoisted_50 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_51 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-6 mb-4 mb-lg-0" }
const _hoisted_54 = { class: "fv-row mb-0" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "col-lg-6" }
const _hoisted_58 = { class: "fv-row mb-0" }
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "d-flex" }
const _hoisted_62 = {
  id: "kt_signin_submit",
  type: "submit",
  ref: "updateEmailButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_63 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_64 = { class: "row mb-6" }
const _hoisted_65 = { class: "col-lg-4" }
const _hoisted_66 = { class: "fv-row mb-0" }
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = { class: "col-lg-4" }
const _hoisted_70 = { class: "fv-row mb-0" }
const _hoisted_71 = { class: "fv-plugins-message-container" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = { class: "col-lg-4" }
const _hoisted_74 = { class: "fv-row mb-0" }
const _hoisted_75 = { class: "fv-plugins-message-container" }
const _hoisted_76 = { class: "fv-help-block" }
const _hoisted_77 = { class: "d-flex" }
const _hoisted_78 = {
  id: "kt_password_submit",
  type: "submit",
  ref: "updatePasswordButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_79 = { class: "card mb-5 mb-xl-10" }
const _hoisted_80 = {
  id: "kt_account_connected_accounts",
  class: "collapse show"
}
const _hoisted_81 = { class: "card-body border-top p-9" }
const _hoisted_82 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6" }
const _hoisted_83 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_84 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_85 = { class: "card mb-5 mb-xl-10" }
const _hoisted_86 = {
  id: "kt_account_email_preferences",
  class: "collapse show"
}
const _hoisted_87 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_88 = {
  ref: "submitButton3",
  type: "submit",
  class: "btn btn-primary px-6"
}
const _hoisted_89 = { class: "card mb-5 mb-xl-10" }
const _hoisted_90 = {
  id: "kt_account_notifications",
  class: "collapse show"
}
const _hoisted_91 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_92 = {
  ref: "submitButton4",
  type: "submit",
  class: "btn btn-primary px-6"
}
const _hoisted_93 = { class: "card mb-5 mb-xl-10" }
const _hoisted_94 = {
  id: "kt_account_deactivate",
  class: "collapse show"
}
const _hoisted_95 = { class: "card-body border-top p-9" }
const _hoisted_96 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6" }
const _hoisted_97 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_98 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_99 = {
  id: "kt_account_deactivate_account_submit",
  ref: "submitButton5",
  type: "submit",
  class: "btn btn-danger fw-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[41] || (_cache[41] = _createElementVNode("div", {
        class: "card-header border-0 cursor-pointer",
        role: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#kt_account_profile_details",
        "aria-expanded": "true",
        "aria-controls": "kt_account_profile_details"
      }, [
        _createElementVNode("div", { class: "card-title m-0" }, [
          _createElementVNode("h3", { class: "fw-bolder m-0" }, "Profile Details")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveChanges1())),
          "validation-schema": _ctx.profileDetailsValidator
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Avatar (examples field)", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "image-input-wrapper w-125px h-125px",
                      style: _normalizeStyle(`background-image: url(${_ctx.profileDetails.avatar}); background-position:center`)
                    }, null, 4),
                    _createElementVNode("label", _hoisted_7, [
                      _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)),
                      _createElementVNode("input", {
                        type: "file",
                        name: "avatar",
                        accept: ".png, .jpg, .jpeg",
                        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChangeImg && _ctx.handleChangeImg(...args)))
                      }, null, 32)
                    ]),
                    _createElementVNode("span", {
                      class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
                      "data-kt-image-input-action": "remove",
                      "data-bs-toggle": "tooltip",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeImage())),
                      title: "Remove avatar"
                    }, _cache[22] || (_cache[22] = [
                      _createElementVNode("i", { class: "bi bi-x fs-2" }, null, -1)
                    ]))
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "form-text" }, "Allowed file types: png, jpg, jpeg.", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Full Name", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "fname",
                        class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                        placeholder: "First name",
                        modelValue: _ctx.profileDetails.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileDetails.name) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_ErrorMessage, { name: "fname" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "lname",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: "Last name",
                        modelValue: _ctx.profileDetails.surname,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profileDetails.surname) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "lname" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Company", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_Field, {
                    disabled: "",
                    type: "text",
                    name: "company",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Company name",
                    modelValue: _ctx.profileDetails.company,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profileDetails.company) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_ErrorMessage, { name: "company" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
                  _createElementVNode("span", { class: "required" }, "Contact Phone"),
                  _createElementVNode("i", {
                    class: "fas fa-exclamation-circle ms-1 fs-7",
                    "data-bs-toggle": "tooltip",
                    title: "Phone number must be active"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_Field, {
                    type: "tel",
                    name: "phone",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Phone number",
                    modelValue: _ctx.profileDetails.contactPhone,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.profileDetails.contactPhone) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_ErrorMessage, { name: "phone" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Company Site (examples field)", -1)),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "website",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Company website",
                    modelValue: _ctx.profileDetails.companySite,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.profileDetails.companySite) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_ErrorMessage, { name: "website" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
                  _createElementVNode("span", { class: "required" }, "Country (examples field)"),
                  _createElementVNode("i", {
                    class: "fas fa-exclamation-circle ms-1 fs-7",
                    "data-bs-toggle": "tooltip",
                    title: "Country of origination"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "country",
                    class: "form-select form-select-solid form-select-lg fw-bold",
                    modelValue: _ctx.profileDetails.country,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.profileDetails.country) = $event)),
                    id: "test"
                  }, {
                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                      _createElementVNode("option", { value: "AF" }, "Afghanistan", -1),
                      _createElementVNode("option", { value: "AX" }, "Aland Islands", -1),
                      _createElementVNode("option", { value: "AL" }, "Albania", -1),
                      _createElementVNode("option", { value: "DZ" }, "Algeria", -1),
                      _createElementVNode("option", { value: "AS" }, "American Samoa", -1),
                      _createElementVNode("option", { value: "AD" }, "Andorra", -1),
                      _createElementVNode("option", { value: "AO" }, "Angola", -1),
                      _createElementVNode("option", { value: "AI" }, "Anguilla", -1),
                      _createElementVNode("option", { value: "AQ" }, "Antarctica", -1),
                      _createElementVNode("option", { value: "AG" }, "Antigua and Barbuda", -1),
                      _createElementVNode("option", { value: "AR" }, "Argentina", -1),
                      _createElementVNode("option", { value: "AM" }, "Armenia", -1),
                      _createElementVNode("option", { value: "AW" }, "Aruba", -1),
                      _createElementVNode("option", { value: "AU" }, "Australia", -1),
                      _createElementVNode("option", { value: "AT" }, "Austria", -1),
                      _createElementVNode("option", { value: "AZ" }, "Azerbaijan", -1),
                      _createElementVNode("option", { value: "BS" }, "Bahamas", -1),
                      _createElementVNode("option", { value: "BH" }, "Bahrain", -1),
                      _createElementVNode("option", { value: "BD" }, "Bangladesh", -1),
                      _createElementVNode("option", { value: "BB" }, "Barbados", -1),
                      _createElementVNode("option", { value: "BY" }, "Belarus", -1),
                      _createElementVNode("option", { value: "BE" }, "Belgium", -1),
                      _createElementVNode("option", { value: "BZ" }, "Belize", -1),
                      _createElementVNode("option", { value: "BJ" }, "Benin", -1),
                      _createElementVNode("option", { value: "BM" }, "Bermuda", -1),
                      _createElementVNode("option", { value: "BT" }, "Bhutan", -1),
                      _createElementVNode("option", { value: "BO" }, "Bolivia, Plurinational State of", -1),
                      _createElementVNode("option", { value: "BQ" }, "Bonaire, Sint Eustatius and Saba", -1),
                      _createElementVNode("option", { value: "BA" }, "Bosnia and Herzegovina", -1),
                      _createElementVNode("option", { value: "BW" }, "Botswana", -1),
                      _createElementVNode("option", { value: "BV" }, "Bouvet Island", -1),
                      _createElementVNode("option", { value: "BR" }, "Brazil", -1),
                      _createElementVNode("option", { value: "IO" }, "British Indian Ocean Territory", -1),
                      _createElementVNode("option", { value: "BN" }, "Brunei Darussalam", -1),
                      _createElementVNode("option", { value: "BG" }, "Bulgaria", -1),
                      _createElementVNode("option", { value: "BF" }, "Burkina Faso", -1),
                      _createElementVNode("option", { value: "BI" }, "Burundi", -1),
                      _createElementVNode("option", { value: "KH" }, "Cambodia", -1),
                      _createElementVNode("option", { value: "CM" }, "Cameroon", -1),
                      _createElementVNode("option", { value: "CA" }, "Canada", -1),
                      _createElementVNode("option", { value: "CV" }, "Cape Verde", -1),
                      _createElementVNode("option", { value: "KY" }, "Cayman Islands", -1),
                      _createElementVNode("option", { value: "CF" }, "Central African Republic", -1),
                      _createElementVNode("option", { value: "TD" }, "Chad", -1),
                      _createElementVNode("option", { value: "CL" }, "Chile", -1),
                      _createElementVNode("option", { value: "CN" }, "China", -1),
                      _createElementVNode("option", { value: "CX" }, "Christmas Island", -1),
                      _createElementVNode("option", { value: "CC" }, "Cocos (Keeling) Islands", -1),
                      _createElementVNode("option", { value: "CO" }, "Colombia", -1),
                      _createElementVNode("option", { value: "KM" }, "Comoros", -1),
                      _createElementVNode("option", { value: "CG" }, "Congo", -1),
                      _createElementVNode("option", { value: "CD" }, " Congo, the Democratic Republic of the ", -1),
                      _createElementVNode("option", { value: "CK" }, "Cook Islands", -1),
                      _createElementVNode("option", { value: "CR" }, "Costa Rica", -1),
                      _createElementVNode("option", { value: "CI" }, "Côte d'Ivoire", -1),
                      _createElementVNode("option", { value: "HR" }, "Croatia", -1),
                      _createElementVNode("option", { value: "CU" }, "Cuba", -1),
                      _createElementVNode("option", { value: "CW" }, "Curaçao", -1),
                      _createElementVNode("option", { value: "CY" }, "Cyprus", -1),
                      _createElementVNode("option", { value: "CZ" }, "Czech Republic", -1),
                      _createElementVNode("option", { value: "DK" }, "Denmark", -1),
                      _createElementVNode("option", { value: "DJ" }, "Djibouti", -1),
                      _createElementVNode("option", { value: "DM" }, "Dominica", -1),
                      _createElementVNode("option", { value: "DO" }, "Dominican Republic", -1),
                      _createElementVNode("option", { value: "EC" }, "Ecuador", -1),
                      _createElementVNode("option", { value: "EG" }, "Egypt", -1),
                      _createElementVNode("option", { value: "SV" }, "El Salvador", -1),
                      _createElementVNode("option", { value: "GQ" }, "Equatorial Guinea", -1),
                      _createElementVNode("option", { value: "ER" }, "Eritrea", -1),
                      _createElementVNode("option", { value: "EE" }, "Estonia", -1),
                      _createElementVNode("option", { value: "ET" }, "Ethiopia", -1),
                      _createElementVNode("option", { value: "FK" }, "Falkland Islands (Malvinas)", -1),
                      _createElementVNode("option", { value: "FO" }, "Faroe Islands", -1),
                      _createElementVNode("option", { value: "FJ" }, "Fiji", -1),
                      _createElementVNode("option", { value: "FI" }, "Finland", -1),
                      _createElementVNode("option", { value: "FR" }, "France", -1),
                      _createElementVNode("option", { value: "GF" }, "French Guiana", -1),
                      _createElementVNode("option", { value: "PF" }, "French Polynesia", -1),
                      _createElementVNode("option", { value: "TF" }, "French Southern Territories", -1),
                      _createElementVNode("option", { value: "GA" }, "Gabon", -1),
                      _createElementVNode("option", { value: "GM" }, "Gambia", -1),
                      _createElementVNode("option", { value: "GE" }, "Georgia", -1),
                      _createElementVNode("option", { value: "DE" }, "Germany", -1),
                      _createElementVNode("option", { value: "GH" }, "Ghana", -1),
                      _createElementVNode("option", { value: "GI" }, "Gibraltar", -1),
                      _createElementVNode("option", { value: "GR" }, "Greece", -1),
                      _createElementVNode("option", { value: "GL" }, "Greenland", -1),
                      _createElementVNode("option", { value: "GD" }, "Grenada", -1),
                      _createElementVNode("option", { value: "GP" }, "Guadeloupe", -1),
                      _createElementVNode("option", { value: "GU" }, "Guam", -1),
                      _createElementVNode("option", { value: "GT" }, "Guatemala", -1),
                      _createElementVNode("option", { value: "GG" }, "Guernsey", -1),
                      _createElementVNode("option", { value: "GN" }, "Guinea", -1),
                      _createElementVNode("option", { value: "GW" }, "Guinea-Bissau", -1),
                      _createElementVNode("option", { value: "GY" }, "Guyana", -1),
                      _createElementVNode("option", { value: "HT" }, "Haiti", -1),
                      _createElementVNode("option", { value: "HM" }, "Heard Island and McDonald Islands", -1),
                      _createElementVNode("option", { value: "VA" }, "Holy See (Vatican City State)", -1),
                      _createElementVNode("option", { value: "HN" }, "Honduras", -1),
                      _createElementVNode("option", { value: "HK" }, "Hong Kong", -1),
                      _createElementVNode("option", { value: "HU" }, "Hungary", -1),
                      _createElementVNode("option", { value: "IS" }, "Iceland", -1),
                      _createElementVNode("option", { value: "IN" }, "India", -1),
                      _createElementVNode("option", { value: "ID" }, "Indonesia", -1),
                      _createElementVNode("option", { value: "IR" }, "Iran, Islamic Republic of", -1),
                      _createElementVNode("option", { value: "IQ" }, "Iraq", -1),
                      _createElementVNode("option", { value: "IE" }, "Ireland", -1),
                      _createElementVNode("option", { value: "IM" }, "Isle of Man", -1),
                      _createElementVNode("option", { value: "IL" }, "Israel", -1),
                      _createElementVNode("option", { value: "IT" }, "Italy", -1),
                      _createElementVNode("option", { value: "JM" }, "Jamaica", -1),
                      _createElementVNode("option", { value: "JP" }, "Japan", -1),
                      _createElementVNode("option", { value: "JE" }, "Jersey", -1),
                      _createElementVNode("option", { value: "JO" }, "Jordan", -1),
                      _createElementVNode("option", { value: "KZ" }, "Kazakhstan", -1),
                      _createElementVNode("option", { value: "KE" }, "Kenya", -1),
                      _createElementVNode("option", { ue: "KI" }, "Kiribati", -1),
                      _createElementVNode("option", { value: "KP" }, " Korea, Democratic People's Republic of ", -1),
                      _createElementVNode("option", { value: "KW" }, "Kuwait", -1),
                      _createElementVNode("option", { value: "KG" }, "Kyrgyzstan", -1),
                      _createElementVNode("option", { value: "LA" }, "Lao People's Democratic Republic", -1),
                      _createElementVNode("option", { value: "LV" }, "Latvia", -1),
                      _createElementVNode("option", { value: "LB" }, "Lebanon", -1),
                      _createElementVNode("option", { value: "LS" }, "Lesotho", -1),
                      _createElementVNode("option", { value: "LR" }, "Liberia", -1),
                      _createElementVNode("option", { value: "LY" }, "Libya", -1),
                      _createElementVNode("option", { value: "LI" }, "Liechtenstein", -1),
                      _createElementVNode("option", { value: "LT" }, "Lithuania", -1),
                      _createElementVNode("option", { value: "LU" }, "Luxembourg", -1),
                      _createElementVNode("option", { value: "MO" }, "Macao", -1),
                      _createElementVNode("option", { value: "MK" }, " Macedonia, the former Yugoslav Republic of ", -1),
                      _createElementVNode("option", { value: "MG" }, "Madagascar", -1),
                      _createElementVNode("option", { value: "MW" }, "Malawi", -1),
                      _createElementVNode("option", { value: "MY" }, "Malaysia", -1),
                      _createElementVNode("option", { value: "MV" }, "Maldives", -1),
                      _createElementVNode("option", { value: "ML" }, "Mali", -1),
                      _createElementVNode("option", { value: "MT" }, "Malta", -1),
                      _createElementVNode("option", { value: "MH" }, "Marshall Islands", -1),
                      _createElementVNode("option", { value: "MQ" }, "Martinique", -1),
                      _createElementVNode("option", { value: "MR" }, "Mauritania", -1),
                      _createElementVNode("option", { value: "MU" }, "Mauritius", -1),
                      _createElementVNode("option", { value: "YT" }, "Mayotte", -1),
                      _createElementVNode("option", { value: "MX" }, "Mexico", -1),
                      _createElementVNode("option", { value: "FM" }, "Micronesia, Federated States of", -1),
                      _createElementVNode("option", { value: "MD" }, "Moldova, Republic of", -1),
                      _createElementVNode("option", { value: "MC" }, "Monaco", -1),
                      _createElementVNode("option", { value: "MN" }, "Mongolia", -1),
                      _createElementVNode("option", { value: "ME" }, "Montenegro", -1),
                      _createElementVNode("option", { value: "MS" }, "Montserrat", -1),
                      _createElementVNode("option", { value: "MA" }, "Morocco", -1),
                      _createElementVNode("option", { value: "MZ" }, "Mozambique", -1),
                      _createElementVNode("option", { value: "MM" }, "Myanmar", -1),
                      _createElementVNode("option", { value: "NA" }, "Namibia", -1),
                      _createElementVNode("option", { value: "NR" }, "Nauru", -1),
                      _createElementVNode("option", { value: "NP" }, "Nepal", -1),
                      _createElementVNode("option", { value: "NL" }, "Netherlands", -1),
                      _createElementVNode("option", { value: "NC" }, "New Caledonia", -1),
                      _createElementVNode("option", { value: "NZ" }, "New Zealand", -1),
                      _createElementVNode("option", { value: "NI" }, "Nicaragua", -1),
                      _createElementVNode("option", { value: "NE" }, "Niger", -1),
                      _createElementVNode("option", { value: "NG" }, "Nigeria", -1),
                      _createElementVNode("option", { value: "NU" }, "Niue", -1),
                      _createElementVNode("option", { value: "NF" }, "Norfolk Island", -1),
                      _createElementVNode("option", { value: "MP" }, "Northern Mariana Islands", -1),
                      _createElementVNode("option", { value: "NO" }, "Norway", -1),
                      _createElementVNode("option", { value: "OM" }, "Oman", -1),
                      _createElementVNode("option", { value: "PK" }, "Pakistan", -1),
                      _createElementVNode("option", { value: "PW" }, "Palau", -1),
                      _createElementVNode("option", { value: "PS" }, "Palestinian Territory, Occupied", -1),
                      _createElementVNode("option", { value: "PA" }, "Panama", -1),
                      _createElementVNode("option", { value: "PG" }, "Papua New Guinea", -1),
                      _createElementVNode("option", { value: "PY" }, "Paraguay", -1),
                      _createElementVNode("option", { value: "PE" }, "Peru", -1),
                      _createElementVNode("option", { value: "PH" }, "Philippines", -1),
                      _createElementVNode("option", { value: "PN" }, "Pitcairn", -1),
                      _createElementVNode("option", { value: "PL" }, "Poland", -1),
                      _createElementVNode("option", { value: "PT" }, "Portugal", -1),
                      _createElementVNode("option", { value: "PR" }, "Puerto Rico", -1),
                      _createElementVNode("option", { value: "QA" }, "Qatar", -1),
                      _createElementVNode("option", { value: "RE" }, "Réunion", -1),
                      _createElementVNode("option", { value: "RO" }, "Romania", -1),
                      _createElementVNode("option", { value: "RU" }, "Russian Federation", -1),
                      _createElementVNode("option", { value: "RW" }, "Rwanda", -1),
                      _createElementVNode("option", { value: "BL" }, "Saint Barthélemy", -1),
                      _createElementVNode("option", { value: "SH" }, " Saint Helena, Ascension and Tristan da Cunha ", -1),
                      _createElementVNode("option", { value: "KN" }, "Saint Kitts and Nevis", -1),
                      _createElementVNode("option", { value: "LC" }, "Saint Lucia", -1),
                      _createElementVNode("option", { value: "MF" }, "Saint Martin (French part)", -1),
                      _createElementVNode("option", { value: "PM" }, "Saint Pierre and Miquelon", -1),
                      _createElementVNode("option", { value: "VC" }, "Saint Vincent and the Grenadines", -1),
                      _createElementVNode("option", { value: "WS" }, "Samoa", -1),
                      _createElementVNode("option", { value: "SM" }, "San Marino", -1),
                      _createElementVNode("option", { value: "ST" }, "Sao Tome and Principe", -1),
                      _createElementVNode("option", { value: "SA" }, "Saudi Arabia", -1),
                      _createElementVNode("option", { value: "SN" }, "Senegal", -1),
                      _createElementVNode("option", { value: "RS" }, "Serbia", -1),
                      _createElementVNode("option", { value: "SC" }, "Seychelles", -1),
                      _createElementVNode("option", { value: "SL" }, "Sierra Leone", -1),
                      _createElementVNode("option", { value: "SG" }, "Singapore", -1),
                      _createElementVNode("option", { value: "SX" }, "Sint Maarten (Dutch part)", -1),
                      _createElementVNode("option", { value: "SK" }, "Slovakia", -1),
                      _createElementVNode("option", { value: "SI" }, "Slovenia", -1),
                      _createElementVNode("option", { value: "SB" }, "Solomon Islands", -1),
                      _createElementVNode("option", { value: "SO" }, "Somalia", -1),
                      _createElementVNode("option", { value: "ZA" }, "South Africa", -1),
                      _createElementVNode("option", { value: "GS" }, " South Georgia and the South Sandwich Islands ", -1),
                      _createElementVNode("option", { value: "KR" }, "South Korea", -1),
                      _createElementVNode("option", { value: "SS" }, "South Sudan", -1),
                      _createElementVNode("option", { value: "ES" }, "Spain", -1),
                      _createElementVNode("option", { value: "LK" }, "Sri Lanka", -1),
                      _createElementVNode("option", { value: "SD" }, "Sudan", -1),
                      _createElementVNode("option", { value: "SR" }, "Suriname", -1),
                      _createElementVNode("option", { value: "SJ" }, "Svalbard and Jan Mayen", -1),
                      _createElementVNode("option", { value: "SZ" }, "Swaziland", -1),
                      _createElementVNode("option", { value: "SE" }, "Sweden", -1),
                      _createElementVNode("option", { value: "CH" }, "Switzerland", -1),
                      _createElementVNode("option", { value: "SY" }, "Syrian Arab Republic", -1),
                      _createElementVNode("option", { value: "TW" }, "Taiwan, Province of China", -1),
                      _createElementVNode("option", { value: "TJ" }, "Tajikistan", -1),
                      _createElementVNode("option", { value: "TZ" }, "Tanzania, United Republic of", -1),
                      _createElementVNode("option", { value: "TH" }, "Thailand", -1),
                      _createElementVNode("option", { value: "TL" }, "Timor-Leste", -1),
                      _createElementVNode("option", { value: "TG" }, "Togo", -1),
                      _createElementVNode("option", { value: "TK" }, "Tokelau", -1),
                      _createElementVNode("option", { value: "TO" }, "Tonga", -1),
                      _createElementVNode("option", { value: "TT" }, "Trinidad and Tobago", -1),
                      _createElementVNode("option", { value: "TN" }, "Tunisia", -1),
                      _createElementVNode("option", { value: "TR" }, "Turkey", -1),
                      _createElementVNode("option", { value: "TM" }, "Turkmenistan", -1),
                      _createElementVNode("option", { value: "TC" }, "Turks and Caicos Islands", -1),
                      _createElementVNode("option", { value: "TV" }, "Tuvalu", -1),
                      _createElementVNode("option", { value: "UG" }, "Uganda", -1),
                      _createElementVNode("option", { value: "UA" }, "Ukraine", -1),
                      _createElementVNode("option", { value: "AE" }, "United Arab Emirates", -1),
                      _createElementVNode("option", { value: "GB" }, "United Kingdom", -1),
                      _createElementVNode("option", { value: "US" }, "United States", -1),
                      _createElementVNode("option", { value: "UY" }, "Uruguay", -1),
                      _createElementVNode("option", { value: "UZ" }, "Uzbekistan", -1),
                      _createElementVNode("option", { value: "VU" }, "Vanuatu", -1),
                      _createElementVNode("option", { value: "VE" }, "Venezuela, Bolivarian Republic of", -1),
                      _createElementVNode("option", { value: "VN" }, "Vietnam", -1),
                      _createElementVNode("option", { value: "VI" }, "Virgin Islands", -1),
                      _createElementVNode("option", { value: "WF" }, "Wallis and Futuna", -1),
                      _createElementVNode("option", { value: "EH" }, "Western Sahara", -1),
                      _createElementVNode("option", { value: "YE" }, "Yemen", -1),
                      _createElementVNode("option", { value: "ZM" }, "Zambia", -1),
                      _createElementVNode("option", { value: "ZW" }, "Zimbabwe", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_ErrorMessage, { name: "country" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Language (examples field)", -1)),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "language",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.profileDetails.language,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.profileDetails.language) = $event))
                  }, {
                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                      _createElementVNode("option", { value: "id" }, "Bahasa Indonesia - Indonesian", -1),
                      _createElementVNode("option", { value: "msa" }, "Bahasa Melayu - Malay", -1),
                      _createElementVNode("option", { value: "ca" }, "Català - Catalan", -1),
                      _createElementVNode("option", { value: "cs" }, "Čeština - Czech", -1),
                      _createElementVNode("option", { value: "da" }, "Dansk - Danish", -1),
                      _createElementVNode("option", { value: "de" }, "Deutsch - German", -1),
                      _createElementVNode("option", { value: "en" }, "English", -1),
                      _createElementVNode("option", { value: "en-gb" }, "English UK - British English", -1),
                      _createElementVNode("option", { value: "es" }, "Español - Spanish", -1),
                      _createElementVNode("option", { value: "fil" }, "Filipino", -1),
                      _createElementVNode("option", { value: "fr" }, "Français - French", -1),
                      _createElementVNode("option", { value: "ga" }, "Gaeilge - Irish (beta)", -1),
                      _createElementVNode("option", { value: "gl" }, "Galego - Galician (beta)", -1),
                      _createElementVNode("option", { value: "hr" }, "Hrvatski - Croatian", -1),
                      _createElementVNode("option", { value: "it" }, "Italiano - Italian", -1),
                      _createElementVNode("option", { value: "hu" }, "Magyar - Hungarian", -1),
                      _createElementVNode("option", { value: "nl" }, "Nederlands - Dutch", -1),
                      _createElementVNode("option", { value: "no" }, "Norsk - Norwegian", -1),
                      _createElementVNode("option", { value: "pl" }, "Polski - Polish", -1),
                      _createElementVNode("option", { value: "pt" }, "Português - Portuguese", -1),
                      _createElementVNode("option", { value: "ro" }, "Română - Romanian", -1),
                      _createElementVNode("option", { value: "sk" }, "Slovenčina - Slovak", -1),
                      _createElementVNode("option", { value: "fi" }, "Suomi - Finnish", -1),
                      _createElementVNode("option", { value: "sv" }, "Svenska - Swedish", -1),
                      _createElementVNode("option", { value: "vi" }, "Tiếng Việt - Vietnamese", -1),
                      _createElementVNode("option", { value: "tr" }, "Türkçe - Turkish", -1),
                      _createElementVNode("option", { value: "el" }, "Ελληνικά - Greek", -1),
                      _createElementVNode("option", { value: "bg" }, "Български език - Bulgarian", -1),
                      _createElementVNode("option", { value: "ru" }, "Русский - Russian", -1),
                      _createElementVNode("option", { value: "sr" }, "Српски - Serbian", -1),
                      _createElementVNode("option", { value: "uk" }, "Українська мова - Ukrainian", -1),
                      _createElementVNode("option", { value: "he" }, "עִבְרִית - Hebrew", -1),
                      _createElementVNode("option", { value: "ur" }, "اردو - Urdu (beta)", -1),
                      _createElementVNode("option", { value: "ar" }, "العربية - Arabic", -1),
                      _createElementVNode("option", { value: "fa" }, "فارسی - Persian", -1),
                      _createElementVNode("option", { value: "mr" }, "मराठी - Marathi", -1),
                      _createElementVNode("option", { value: "hi" }, "हिन्दी - Hindi", -1),
                      _createElementVNode("option", { value: "bn" }, "বাংলা - Bangla", -1),
                      _createElementVNode("option", { value: "gu" }, "ગુજરાતી - Gujarati", -1),
                      _createElementVNode("option", { value: "ta" }, "தமிழ் - Tamil", -1),
                      _createElementVNode("option", { value: "kn" }, "ಕನ್ನಡ - Kannada", -1),
                      _createElementVNode("option", { value: "th" }, "ภาษาไทย - Thai", -1),
                      _createElementVNode("option", { value: "ko" }, "한국어 - Korean", -1),
                      _createElementVNode("option", { value: "ja" }, "日本語 - Japanese", -1),
                      _createElementVNode("option", { value: "zh-cn" }, "简体中文 - Simplified Chinese", -1),
                      _createElementVNode("option", { value: "zh-tw" }, "繁體中文 - Traditional Chinese", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_ErrorMessage, { name: "language" })
                    ])
                  ]),
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "form-text" }, " Please select a preferred language, including date, time, and number formatting. ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Time Zone (examples field)", -1)),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "timezone",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.profileDetails.timezone,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.profileDetails.timezone) = $event))
                  }, {
                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                      _createElementVNode("option", {
                        "data-bs-offset": "-39600",
                        value: "International Date Line West"
                      }, " (GMT-11:00) International Date Line West ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-39600",
                        value: "Midway Island"
                      }, " (GMT-11:00) Midway Island ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-39600",
                        value: "Samoa"
                      }, " (GMT-11:00) Samoa ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-36000",
                        value: "Hawaii"
                      }, " (GMT-10:00) Hawaii ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-28800",
                        value: "Alaska"
                      }, " (GMT-08:00) Alaska ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-25200",
                        value: "Pacific Time (US & Canada)"
                      }, " (GMT-07:00) Pacific Time (US & Canada) ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-25200",
                        value: "Tijuana"
                      }, " (GMT-07:00) Tijuana ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-25200",
                        value: "Arizona"
                      }, " (GMT-07:00) Arizona ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-21600",
                        value: "Mountain Time (US & Canada)"
                      }, " (GMT-06:00) Mountain Time (US & Canada) ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-21600",
                        value: "Chihuahua"
                      }, " (GMT-06:00) Chihuahua ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-21600",
                        value: "Mazatlan"
                      }, " (GMT-06:00) Mazatlan ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-21600",
                        value: "Saskatchewan"
                      }, " (GMT-06:00) Saskatchewan ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-21600",
                        value: "Central America"
                      }, " (GMT-06:00) Central America ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-18000",
                        value: "Central Time (US & Canada)"
                      }, " (GMT-05:00) Central Time (US & Canada) ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-18000",
                        value: "Guadalajara"
                      }, " (GMT-05:00) Guadalajara ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-18000",
                        value: "Mexico City"
                      }, " (GMT-05:00) Mexico City ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-18000",
                        value: "Monterrey"
                      }, " (GMT-05:00) Monterrey ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-18000",
                        value: "Bogota"
                      }, " (GMT-05:00) Bogota ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-18000",
                        value: "Lima"
                      }, " (GMT-05:00) Lima ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-18000",
                        value: "Quito"
                      }, " (GMT-05:00) Quito ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-14400",
                        value: "Eastern Time (US & Canada)"
                      }, " (GMT-04:00) Eastern Time (US & Canada) ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-14400",
                        value: "Indiana (East)"
                      }, " (GMT-04:00) Indiana (East) ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-14400",
                        value: "Caracas"
                      }, " (GMT-04:00) Caracas ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-14400",
                        value: "La Paz"
                      }, " (GMT-04:00) La Paz ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-14400",
                        value: "Georgetown"
                      }, " (GMT-04:00) Georgetown ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-10800",
                        value: "Atlantic Time (Canada)"
                      }, " (GMT-03:00) Atlantic Time (Canada) ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-10800",
                        value: "Santiago"
                      }, " (GMT-03:00) Santiago ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-10800",
                        value: "Brasilia"
                      }, " (GMT-03:00) Brasilia ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-10800",
                        value: "Buenos Aires"
                      }, " (GMT-03:00) Buenos Aires ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-9000",
                        value: "Newfoundland"
                      }, " (GMT-02:30) Newfoundland ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-7200",
                        value: "Greenland"
                      }, " (GMT-02:00) Greenland ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-7200",
                        value: "Mid-Atlantic"
                      }, " (GMT-02:00) Mid-Atlantic ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "-3600",
                        value: "Cape Verde Is."
                      }, " (GMT-01:00) Cape Verde Is. ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "0",
                        value: "Azores"
                      }, "(GMT) Azores", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "0",
                        value: "Monrovia"
                      }, " (GMT) Monrovia ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "0",
                        value: "UTC"
                      }, "(GMT) UTC", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "3600",
                        value: "Dublin"
                      }, " (GMT+01:00) Dublin ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "3600",
                        value: "Edinburgh"
                      }, " (GMT+01:00) Edinburgh ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "3600",
                        value: "Lisbon"
                      }, " (GMT+01:00) Lisbon ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "3600",
                        value: "London"
                      }, " (GMT+01:00) London ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "3600",
                        value: "Casablanca"
                      }, " (GMT+01:00) Casablanca ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "3600",
                        value: "West Central Africa"
                      }, " (GMT+01:00) West Central Africa ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Belgrade"
                      }, " (GMT+02:00) Belgrade ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Bratislava"
                      }, " (GMT+02:00) Bratislava ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Budapest"
                      }, " (GMT+02:00) Budapest ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Ljubljana"
                      }, " (GMT+02:00) Ljubljana ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Prague"
                      }, " (GMT+02:00) Prague ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Sarajevo"
                      }, " (GMT+02:00) Sarajevo ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Skopje"
                      }, " (GMT+02:00) Skopje ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Warsaw"
                      }, " (GMT+02:00) Warsaw ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Zagreb"
                      }, " (GMT+02:00) Zagreb ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Brussels"
                      }, " (GMT+02:00) Brussels ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Copenhagen"
                      }, " (GMT+02:00) Copenhagen ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Madrid"
                      }, " (GMT+02:00) Madrid ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Paris"
                      }, " (GMT+02:00) Paris ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Amsterdam"
                      }, " (GMT+02:00) Amsterdam ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Berlin"
                      }, " (GMT+02:00) Berlin ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Bern"
                      }, " (GMT+02:00) Bern ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Rome"
                      }, " (GMT+02:00) Rome ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Stockholm"
                      }, " (GMT+02:00) Stockholm ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Vienna"
                      }, " (GMT+02:00) Vienna ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Cairo"
                      }, " (GMT+02:00) Cairo ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Harare"
                      }, " (GMT+02:00) Harare ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "7200",
                        value: "Pretoria"
                      }, " (GMT+02:00) Pretoria ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Bucharest"
                      }, " (GMT+03:00) Bucharest ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Helsinki"
                      }, " (GMT+03:00) Helsinki ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Kiev"
                      }, " (GMT+03:00) Kiev ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Kyiv"
                      }, " (GMT+03:00) Kyiv ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Riga"
                      }, " (GMT+03:00) Riga ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Sofia"
                      }, " (GMT+03:00) Sofia ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Tallinn"
                      }, " (GMT+03:00) Tallinn ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Vilnius"
                      }, " (GMT+03:00) Vilnius ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Athens"
                      }, " (GMT+03:00) Athens ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Istanbul"
                      }, " (GMT+03:00) Istanbul ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Minsk"
                      }, " (GMT+03:00) Minsk ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Jerusalem"
                      }, " (GMT+03:00) Jerusalem ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Moscow"
                      }, " (GMT+03:00) Moscow ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "St. Petersburg"
                      }, " (GMT+03:00) St. Petersburg ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Volgograd"
                      }, " (GMT+03:00) Volgograd ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Kuwait"
                      }, " (GMT+03:00) Kuwait ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Riyadh"
                      }, " (GMT+03:00) Riyadh ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Nairobi"
                      }, " (GMT+03:00) Nairobi ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "10800",
                        value: "Baghdad"
                      }, " (GMT+03:00) Baghdad ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "14400",
                        value: "Abu Dhabi"
                      }, " (GMT+04:00) Abu Dhabi ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "14400",
                        value: "Muscat"
                      }, " (GMT+04:00) Muscat ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "14400",
                        value: "Baku"
                      }, " (GMT+04:00) Baku ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "14400",
                        value: "Tbilisi"
                      }, " (GMT+04:00) Tbilisi ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "14400",
                        value: "Yerevan"
                      }, " (GMT+04:00) Yerevan ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "16200",
                        value: "Tehran"
                      }, " (GMT+04:30) Tehran ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "16200",
                        value: "Kabul"
                      }, " (GMT+04:30) Kabul ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "18000",
                        value: "Ekaterinburg"
                      }, " (GMT+05:00) Ekaterinburg ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "18000",
                        value: "Islamabad"
                      }, " (GMT+05:00) Islamabad ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "18000",
                        value: "Karachi"
                      }, " (GMT+05:00) Karachi ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "18000",
                        value: "Tashkent"
                      }, " (GMT+05:00) Tashkent ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "19800",
                        value: "Chennai"
                      }, " (GMT+05:30) Chennai ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "19800",
                        value: "Kolkata"
                      }, " (GMT+05:30) Kolkata ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "19800",
                        value: "Mumbai"
                      }, " (GMT+05:30) Mumbai ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "19800",
                        value: "New Delhi"
                      }, " (GMT+05:30) New Delhi ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "19800",
                        value: "Sri Jayawardenepura"
                      }, " (GMT+05:30) Sri Jayawardenepura ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "20700",
                        value: "Kathmandu"
                      }, " (GMT+05:45) Kathmandu ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "21600",
                        value: "Astana"
                      }, " (GMT+06:00) Astana ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "21600",
                        value: "Dhaka"
                      }, " (GMT+06:00) Dhaka ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "21600",
                        value: "Almaty"
                      }, " (GMT+06:00) Almaty ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "21600",
                        value: "Urumqi"
                      }, " (GMT+06:00) Urumqi ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "23400",
                        value: "Rangoon"
                      }, " (GMT+06:30) Rangoon ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "25200",
                        value: "Novosibirsk"
                      }, " (GMT+07:00) Novosibirsk ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "25200",
                        value: "Bangkok"
                      }, " (GMT+07:00) Bangkok ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "25200",
                        value: "Hanoi"
                      }, " (GMT+07:00) Hanoi ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "25200",
                        value: "Jakarta"
                      }, " (GMT+07:00) Jakarta ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "25200",
                        value: "Krasnoyarsk"
                      }, " (GMT+07:00) Krasnoyarsk ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "28800",
                        value: "Beijing"
                      }, " (GMT+08:00) Beijing ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "28800",
                        value: "Chongqing"
                      }, " (GMT+08:00) Chongqing ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "28800",
                        value: "Hong Kong"
                      }, " (GMT+08:00) Hong Kong ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "28800",
                        value: "Kuala Lumpur"
                      }, " (GMT+08:00) Kuala Lumpur ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "28800",
                        value: "Singapore"
                      }, " (GMT+08:00) Singapore ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "28800",
                        value: "Taipei"
                      }, " (GMT+08:00) Taipei ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "28800",
                        value: "Perth"
                      }, " (GMT+08:00) Perth ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "28800",
                        value: "Irkutsk"
                      }, " (GMT+08:00) Irkutsk ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "28800",
                        value: "Ulaan Bataar"
                      }, " (GMT+08:00) Ulaan Bataar ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "32400",
                        value: "Seoul"
                      }, " (GMT+09:00) Seoul ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "32400",
                        value: "Osaka"
                      }, " (GMT+09:00) Osaka ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "32400",
                        value: "Sapporo"
                      }, " (GMT+09:00) Sapporo ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "32400",
                        value: "Tokyo"
                      }, " (GMT+09:00) Tokyo ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "32400",
                        value: "Yakutsk"
                      }, " (GMT+09:00) Yakutsk ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "34200",
                        value: "Darwin"
                      }, " (GMT+09:30) Darwin ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "34200",
                        value: "Adelaide"
                      }, " (GMT+09:30) Adelaide ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "36000",
                        value: "Canberra"
                      }, " (GMT+10:00) Canberra ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "36000",
                        value: "Melbourne"
                      }, " (GMT+10:00) Melbourne ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "36000",
                        value: "Sydney"
                      }, " (GMT+10:00) Sydney ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "36000",
                        value: "Brisbane"
                      }, " (GMT+10:00) Brisbane ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "36000",
                        value: "Hobart"
                      }, " (GMT+10:00) Hobart ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "36000",
                        value: "Vladivostok"
                      }, " (GMT+10:00) Vladivostok ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "36000",
                        value: "Guam"
                      }, " (GMT+10:00) Guam ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "36000",
                        value: "Port Moresby"
                      }, " (GMT+10:00) Port Moresby ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "36000",
                        value: "Solomon Is."
                      }, " (GMT+10:00) Solomon Is. ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "39600",
                        value: "Magadan"
                      }, " (GMT+11:00) Magadan ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "39600",
                        value: "New Caledonia"
                      }, " (GMT+11:00) New Caledonia ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "43200",
                        value: "Fiji"
                      }, " (GMT+12:00) Fiji ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "43200",
                        value: "Kamchatka"
                      }, " (GMT+12:00) Kamchatka ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "43200",
                        value: "Marshall Is."
                      }, " (GMT+12:00) Marshall Is. ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "43200",
                        value: "Auckland"
                      }, " (GMT+12:00) Auckland ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "43200",
                        value: "Wellington"
                      }, " (GMT+12:00) Wellington ", -1),
                      _createElementVNode("option", {
                        "data-bs-offset": "46800",
                        value: "Nuku'alofa"
                      }, " (GMT+13:00) Nuku'alofa ", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_ErrorMessage, { name: "timezone" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Currency (examples field)", -1)),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_ErrorMessage, { name: "currency" })
                    ])
                  ])
                ])
              ]),
              _cache[37] || (_cache[37] = _createElementVNode("div", { class: "row mb-6" }, [
                _createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Communication (examples field)"),
                _createElementVNode("div", { class: "col-lg-8 fv-row" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center mt-3" }, [
                    _createElementVNode("label", { class: "form-check form-check-inline form-check-solid me-5" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        name: "communication[]",
                        type: "checkbox"
                      }),
                      _createElementVNode("span", { class: "fw-bold ps-2 fs-6" }, " Email ")
                    ]),
                    _createElementVNode("label", { class: "form-check form-check-inline form-check-solid" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        name: "communication[]",
                        type: "checkbox"
                      }),
                      _createElementVNode("span", { class: "fw-bold ps-2 fs-6" }, " Phone ")
                    ])
                  ])
                ])
              ], -1)),
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "row mb-0" }, [
                _createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Allow Marketing (examples field)"),
                _createElementVNode("div", { class: "col-lg-8 d-flex align-items-center" }, [
                  _createElementVNode("div", { class: "form-check form-check-solid form-switch fv-row" }, [
                    _createElementVNode("input", {
                      class: "form-check-input w-45px h-30px",
                      type: "checkbox",
                      id: "allowmarketing"
                    }),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: "allowmarketing"
                    })
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_45, [
              _cache[40] || (_cache[40] = _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2"
              }, " Discard ", -1)),
              _createElementVNode("button", _hoisted_46, _cache[39] || (_cache[39] = [
                _createElementVNode("span", { class: "indicator-label" }, " Save Changes ", -1),
                _createElementVNode("span", { class: "indicator-progress" }, [
                  _createTextVNode(" Please wait... "),
                  _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
                ], -1)
              ]), 512)
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _cache[52] || (_cache[52] = _createElementVNode("div", {
        class: "card-header border-0 cursor-pointer",
        role: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#kt_account_signin_method"
      }, [
        _createElementVNode("div", { class: "card-title m-0" }, [
          _createElementVNode("h3", { class: "fw-boldest m-0" }, "Sign-in Method")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", {
              id: "kt_signin_email",
              class: _normalizeClass({ 'd-none': _ctx.emailFormDisplay })
            }, [
              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Email Address", -1)),
              _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.emailDetails.email), 1)
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_email_edit",
              class: _normalizeClass([{ 'd-none': !_ctx.emailFormDisplay }, "flex-row-fluid"])
            }, [
              _createVNode(_component_Form, {
                id: "kt_signin_change_email",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateEmail())),
                "validation-schema": _ctx.changeEmail
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _cache[43] || (_cache[43] = _createElementVNode("label", {
                          for: "emailaddress",
                          class: "form-label fs-6 fw-bolder mb-3"
                        }, "Enter New Email Address", -1)),
                        _createVNode(_component_Field, {
                          type: "email",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          id: "emailaddress",
                          placeholder: "Email Address",
                          name: "emailaddress",
                          value: _ctx.emailDetails.email
                        }, null, 8, ["value"]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createVNode(_component_ErrorMessage, { name: "emailaddress" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _cache[44] || (_cache[44] = _createElementVNode("label", {
                          for: "confirmemailpassword",
                          class: "form-label fs-6 fw-bolder mb-3"
                        }, "Confirm Password", -1)),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "confirmemailpassword",
                          id: "confirmemailpassword"
                        }),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_ErrorMessage, { name: "confirmemailpassword" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("button", _hoisted_62, _cache[45] || (_cache[45] = [
                      _createElementVNode("span", { class: "indicator-label" }, " Update Email ", -1),
                      _createElementVNode("span", { class: "indicator-progress" }, [
                        _createTextVNode(" Please wait... "),
                        _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
                      ], -1)
                    ]), 512),
                    _createElementVNode("button", {
                      id: "kt_signin_cancel",
                      type: "button",
                      class: "btn btn-color-gray-400 btn-active-light-primary px-6",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.emailFormDisplay = !_ctx.emailFormDisplay))
                    }, " Cancel ")
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_email_button",
              class: _normalizeClass([{ 'd-none': _ctx.emailFormDisplay }, "ms-auto"])
            }, [
              _createElementVNode("button", {
                class: "btn btn-light fw-boldest px-6",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emailFormDisplay = !_ctx.emailFormDisplay))
              }, " Change Email ")
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", {
              id: "kt_signin_password",
              class: _normalizeClass({ 'd-none': _ctx.passwordFormDisplay })
            }, _cache[46] || (_cache[46] = [
              _createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Password", -1),
              _createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
            ]), 2),
            _createElementVNode("div", {
              id: "kt_signin_password_edit",
              class: _normalizeClass(["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }])
            }, [
              _cache[51] || (_cache[51] = _createElementVNode("div", { class: "fs-6 fw-bold text-gray-600 mb-4" }, " Password must be at least 8 character and contain symbols ", -1)),
              _createVNode(_component_Form, {
                id: "kt_signin_change_password",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updatePassword())),
                "validation-schema": _ctx.changePassword
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _cache[47] || (_cache[47] = _createElementVNode("label", {
                          for: "currentpassword",
                          class: "form-label fs-6 fw-bolder mb-3"
                        }, "Current Password", -1)),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "currentpassword",
                          id: "currentpassword"
                        }),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _createVNode(_component_ErrorMessage, { name: "currentpassword" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _cache[48] || (_cache[48] = _createElementVNode("label", {
                          for: "newpassword",
                          class: "form-label fs-6 fw-bolder mb-3"
                        }, "New Password", -1)),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "newpassword",
                          id: "newpassword"
                        }),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_component_ErrorMessage, { name: "newpassword" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _cache[49] || (_cache[49] = _createElementVNode("label", {
                          for: "confirmpassword",
                          class: "form-label fs-6 fw-bolder mb-3"
                        }, "Confirm New Password", -1)),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "confirmpassword",
                          id: "confirmpassword"
                        }),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createVNode(_component_ErrorMessage, { name: "confirmpassword" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("button", _hoisted_78, _cache[50] || (_cache[50] = [
                      _createElementVNode("span", { class: "indicator-label" }, " Update Password ", -1),
                      _createElementVNode("span", { class: "indicator-progress" }, [
                        _createTextVNode(" Please wait... "),
                        _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
                      ], -1)
                    ]), 512),
                    _createElementVNode("button", {
                      id: "kt_password_cancel",
                      type: "button",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                      class: "btn btn-color-gray-400 btn-active-light-primary px-6"
                    }, " Cancel ")
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_password_button",
              class: _normalizeClass(["ms-auto", { 'd-none': _ctx.passwordFormDisplay }])
            }, [
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                class: "btn btn-light fw-boldest"
              }, " Reset Password ")
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_79, [
      _cache[57] || (_cache[57] = _createElementVNode("div", {
        class: "card-header border-0 cursor-pointer",
        role: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#kt_account_connected_accounts",
        "aria-expanded": "true",
        "aria-controls": "kt_account_connected_accounts"
      }, [
        _createElementVNode("div", { class: "card-title m-0" }, [
          _createElementVNode("h3", { class: "fw-bolder m-0" }, "Connected Accounts")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("span", _hoisted_83, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art006.svg" })
            ]),
            _cache[53] || (_cache[53] = _createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
              _createElementVNode("div", { class: "fw-bold" }, [
                _createElementVNode("div", { class: "fs-6 text-gray-600" }, [
                  _createTextVNode(" Two-factor authentication adds an extra layer of security to your account. To log in, in you'll need to provide a 4 digit amazing code. "),
                  _createElementVNode("a", {
                    href: "#",
                    class: "fw-bolder"
                  }, "Learn More")
                ])
              ])
            ], -1))
          ]),
          _cache[54] || (_cache[54] = _createStaticVNode("<div class=\"py-2\"><div class=\"d-flex flex-stack\"><div class=\"d-flex\"><img src=\"media/svg/brand-logos/google-icon.svg\" class=\"w-30px me-6\" alt=\"\"><div class=\"d-flex flex-column\"><a href=\"#\" class=\"fs-5 text-dark text-hover-primary fw-bolder\">Google</a><div class=\"fs-6 fw-bold text-gray-400\"> Plan properly your workflow </div></div></div><div class=\"d-flex justify-content-end\"><div class=\"form-check form-check-solid form-switch\"><input class=\"form-check-input w-45px h-30px\" type=\"checkbox\" id=\"googleswitch\" checked><label class=\"form-check-label\" for=\"googleswitch\"></label></div></div></div><div class=\"separator separator-dashed my-5\"></div><div class=\"d-flex flex-stack\"><div class=\"d-flex\"><img src=\"media/svg/brand-logos/github.svg\" class=\"w-30px me-6\" alt=\"\"><div class=\"d-flex flex-column\"><a href=\"#\" class=\"fs-5 text-dark text-hover-primary fw-bolder\">Github</a><div class=\"fs-6 fw-bold text-gray-400\"> Keep eye on on your Repositories </div></div></div><div class=\"d-flex justify-content-end\"><div class=\"form-check form-check-solid form-switch\"><input class=\"form-check-input w-45px h-30px\" type=\"checkbox\" id=\"githubswitch\" checked><label class=\"form-check-label\" for=\"githubswitch\"></label></div></div></div><div class=\"separator separator-dashed my-5\"></div><div class=\"d-flex flex-stack\"><div class=\"d-flex\"><img src=\"media/svg/brand-logos/slack-icon.svg\" class=\"w-30px me-6\" alt=\"\"><div class=\"d-flex flex-column\"><a href=\"#\" class=\"fs-5 text-dark text-hover-primary fw-bolder\">Slack</a><div class=\"fs-6 fw-bold text-gray-400\"> Integrate Projects Discussions </div></div></div><div class=\"d-flex justify-content-end\"><div class=\"form-check form-check-solid form-switch\"><input class=\"form-check-input w-45px h-30px\" type=\"checkbox\" id=\"slackswitch\"><label class=\"form-check-label\" for=\"slackswitch\"></label></div></div></div></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_84, [
          _cache[56] || (_cache[56] = _createElementVNode("button", { class: "btn btn-white btn-active-light-primary me-2" }, " Discard ", -1)),
          _createElementVNode("button", {
            ref: "submitButton2",
            class: "btn btn-primary",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.saveChanges2()))
          }, _cache[55] || (_cache[55] = [
            _createElementVNode("span", { class: "indicator-label" }, " Save Changes ", -1),
            _createElementVNode("span", { class: "indicator-progress" }, [
              _createTextVNode(" Please wait... "),
              _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
            ], -1)
          ]), 512)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_85, [
      _cache[61] || (_cache[61] = _createElementVNode("div", {
        class: "card-header border-0 cursor-pointer",
        role: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#kt_account_email_preferences",
        "aria-expanded": "true",
        "aria-controls": "kt_account_email_preferences"
      }, [
        _createElementVNode("div", { class: "card-title m-0" }, [
          _createElementVNode("h3", { class: "fw-bolder m-0" }, "Email Preferences")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.saveChanges3()), ["prevent"]))
        }, [
          _cache[60] || (_cache[60] = _createStaticVNode("<div class=\"card-body border-top px-9 py-9\"><label class=\"form-check form-check-custom form-check-solid align-items-start\"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Successful Payments</span><span class=\"text-muted fs-6\">Receive a notification for every successful payment.</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"form-check form-check-custom form-check-solid align-items-start\"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" checked value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Payouts</span><span class=\"text-muted fs-6\">Receive a notification for every initiated payout.</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"form-check form-check-custom form-check-solid align-items-start\"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Fee Collection</span><span class=\"text-muted fs-6\">Receive a notification each time you collect a fee from sales</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"form-check form-check-custom form-check-solid align-items-start\"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" checked value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Customer Payment Dispute</span><span class=\"text-muted fs-6\">Receive a notification if a payment is disputed by a customer and for dispute purposes.</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"form-check form-check-custom form-check-solid align-items-start\"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Refund Alerts</span><span class=\"text-muted fs-6\">Receive a notification if a payment is stated as risk by the Finance Department.</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"form-check form-check-custom form-check-solid align-items-start\"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" checked value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Invoice Payments</span><span class=\"text-muted fs-6\">Receive a notification if a customer sends an incorrect amount to pay their invoice.</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"form-check form-check-custom form-check-solid align-items-start\"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Webhook API Endpoints</span><span class=\"text-muted fs-6\">Receive notifications for consistently failing webhook API endpoints.</span></span></label><div class=\"separator separator-dashed my-6\"></div></div>", 1)),
          _createElementVNode("div", _hoisted_87, [
            _cache[59] || (_cache[59] = _createElementVNode("button", { class: "btn btn-white btn-active-light-primary me-2" }, " Discard ", -1)),
            _createElementVNode("button", _hoisted_88, _cache[58] || (_cache[58] = [
              _createElementVNode("span", { class: "indicator-label" }, " Save Changes ", -1),
              _createElementVNode("span", { class: "indicator-progress" }, [
                _createTextVNode(" Please wait... "),
                _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
              ], -1)
            ]), 512)
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_89, [
      _cache[65] || (_cache[65] = _createElementVNode("div", {
        class: "card-header border-0 cursor-pointer",
        role: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#kt_account_notifications",
        "aria-expanded": "true",
        "aria-controls": "kt_account_notifications"
      }, [
        _createElementVNode("div", { class: "card-title m-0" }, [
          _createElementVNode("h3", { class: "fw-bolder m-0" }, "Notifications")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_90, [
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.saveChanges4()), ["prevent"]))
        }, [
          _cache[64] || (_cache[64] = _createStaticVNode("<div class=\"card-body border-top px-9 pt-3 pb-4\"><div class=\"table-responsive\"><table class=\"table table-row-dashed border-gray-300 align-middle gy-6\"><tbody class=\"fs-6 fw-bold\"><tr><td class=\"min-w-250px fs-4 fw-bolder\">Notifications</td><td class=\"w-125px\"><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"kt_settings_notification_email\" checked data-kt-check=\"true\" data-kt-check-target=\"[data-kt-settings-notification=email]\"><label class=\"form-check-label ps-2\" for=\"kt_settings_notification_email\"> Email </label></div></td><td class=\"w-125px\"><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"kt_settings_notification_phone\" checked data-kt-check=\"true\" data-kt-check-target=\"[data-kt-settings-notification=phone]\"><label class=\"form-check-label ps-2\" for=\"kt_settings_notification_phone\"> Phone </label></div></td></tr><tr><td>Billing Updates</td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"1\" id=\"billing1\" checked data-kt-settings-notification=\"email\"><label class=\"form-check-label ps-2\" for=\"billing1\"></label></div></td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"billing2\" checked data-kt-settings-notification=\"phone\"><label class=\"form-check-label ps-2\" for=\"billing2\"></label></div></td></tr><tr><td>New Team Members</td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"team1\" checked data-kt-settings-notification=\"email\"><label class=\"form-check-label ps-2\" for=\"team1\"></label></div></td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"team2\" data-kt-settings-notification=\"phone\"><label class=\"form-check-label ps-2\" for=\"team2\"></label></div></td></tr><tr><td>Completed Projects</td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"project1\" data-kt-settings-notification=\"email\"><label class=\"form-check-label ps-2\" for=\"project1\"></label></div></td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"project2\" checked data-kt-settings-notification=\"phone\"><label class=\"form-check-label ps-2\" for=\"project2\"></label></div></td></tr><tr><td class=\"border-bottom-0\">Newsletters</td><td class=\"border-bottom-0\"><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"newsletter1\" data-kt-settings-notification=\"email\"><label class=\"form-check-label ps-2\" for=\"newsletter1\"></label></div></td><td class=\"border-bottom-0\"><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"newsletter2\" data-kt-settings-notification=\"phone\"><label class=\"form-check-label ps-2\" for=\"newsletter2\"></label></div></td></tr></tbody></table></div></div>", 1)),
          _createElementVNode("div", _hoisted_91, [
            _cache[63] || (_cache[63] = _createElementVNode("button", { class: "btn btn-white btn-active-light-primary me-2" }, " Discard ", -1)),
            _createElementVNode("button", _hoisted_92, _cache[62] || (_cache[62] = [
              _createElementVNode("span", { class: "indicator-label" }, " Save Changes ", -1),
              _createElementVNode("span", { class: "indicator-progress" }, [
                _createTextVNode(" Please wait... "),
                _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
              ], -1)
            ]), 512)
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_93, [
      _cache[69] || (_cache[69] = _createElementVNode("div", {
        class: "card-header border-0 cursor-pointer",
        role: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#kt_account_deactivate",
        "aria-expanded": "true",
        "aria-controls": "kt_account_deactivate"
      }, [
        _createElementVNode("div", { class: "card-title m-0" }, [
          _createElementVNode("h3", { class: "fw-boldest m-0" }, "Deactivate Account")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("form", {
          id: "kt_account_deactivate_form",
          class: "form",
          onSubmit: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.deactivateAccount()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("span", _hoisted_97, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
              ]),
              _cache[66] || (_cache[66] = _createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> You Are Deactivating Your Account </h4><div class=\"fs-6 text-gray-600\"> For extra security, this requires you to confirm your email or phone number when you reset yousignr password. <br><a class=\"fw-bolder\" href=\"#\">Learn more</a></div></div></div>", 1))
            ]),
            _cache[67] || (_cache[67] = _createElementVNode("div", { class: "form-check form-check-solid fv-row" }, [
              _createElementVNode("input", {
                name: "deactivate",
                class: "form-check-input",
                type: "checkbox",
                value: "",
                id: "deactivate"
              }),
              _createElementVNode("label", {
                class: "form-check-label fw-bold ps-2 fs-6",
                for: "deactivate"
              }, "Confirm Account Deactivation")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("button", _hoisted_99, _cache[68] || (_cache[68] = [
              _createElementVNode("span", { class: "indicator-label" }, " Deactivate Account ", -1),
              _createElementVNode("span", { class: "indicator-progress" }, [
                _createTextVNode(" Please wait... "),
                _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
              ], -1)
            ]), 512)
          ])
        ], 32)
      ])
    ])
  ], 64))
}